// 분석성능경고 게이지의 고유 의약품 수 임계 판정.
// 임계 근거: docs/ai-discussions/20260615-medicine-count-gauge-threshold.md
//   phai_토큰량추정 + AI리뷰보고서(2026-06) 실측, TEST·고유0·이미지표 outlier 제외.
//   ≤39 무실패(보수) / 40–49 ~0% / 50–66 ~28% / 67+ 50~100%(2번째 데이터는 완료 0).
//   임상 보수성 위해 안전 상한을 무실패 상한(49)보다 낮은 39로, 빨강을 67로 설정.
//   ※ 약 수는 토큰의 대리지표라 천장이 그룹마다 62~77로 흔들림 → 주기적 재측정 필요.
export const GAUGE_GREEN_MAX = 39;
export const GAUGE_YELLOW_MAX = 49;
export const GAUGE_ORANGE_MAX = 66;

export type GaugeLevel = "none" | "yellow" | "orange" | "red";

/** 고유 의약품 수 → 경고 단계. "none"은 게이지 미표시(안전). */
export function medicineCountLevel(count: number): GaugeLevel {
  if (count <= GAUGE_GREEN_MAX) return "none";
  if (count <= GAUGE_YELLOW_MAX) return "yellow";
  if (count <= GAUGE_ORANGE_MAX) return "orange";
  return "red";
}
